import { useSyncExternalStore } from 'react';
import { useColorScheme as useRNColorScheme } from 'react-native';

type ColorScheme = 'light' | 'dark';

let forcedScheme: ColorScheme | null = null;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getForcedSnapshot() {
  return forcedScheme;
}

function getServerForcedSnapshot() {
  return null;
}

/** react-native-web has no Appearance.setColorScheme — keep an app-level override. */
export function setAppColorScheme(scheme: ColorScheme): void {
  forcedScheme = scheme;
  listeners.forEach((listener) => listener());
}

const hydrateSubscribe = () => () => {};
const getClientHydrated = () => true;
const getServerHydrated = () => false;

/**
 * To support static rendering, this value needs to be re-calculated on the client side for web
 */
export function useColorScheme() {
  const hasHydrated = useSyncExternalStore(
    hydrateSubscribe,
    getClientHydrated,
    getServerHydrated,
  );
  const forced = useSyncExternalStore(
    subscribe,
    getForcedSnapshot,
    getServerForcedSnapshot,
  );
  const systemScheme = useRNColorScheme();

  if (!hasHydrated) {
    return 'light';
  }

  return forced ?? systemScheme ?? 'light';
}
